import { useSelector } from 'react-redux'

import type { RetailOrderLineItem } from '~/api/graphql/generated/types'
import {
  getIsRetailOrderLineItem,
  isGroupedInvoiceItem,
} from '~/components/dashboard/invoices/invoiceUtils'
import { getIsSetBundlePriceEnabled } from '~/store/reducers/constants'
import type { InvoiceLineItem } from '~/types'

export const useHasGroupedParentWithFixedPrice = (
  parentItem?: InvoiceLineItem | RetailOrderLineItem,
): boolean => {
  const isBundlePriceEnabled = useSelector(getIsSetBundlePriceEnabled)

  return Boolean(
    isBundlePriceEnabled &&
    parentItem &&
    isGroupedInvoiceItem(parentItem) &&
    !getIsRetailOrderLineItem(parentItem) &&
    parentItem?.fixedPrice != null,
  )
}
